import type { QueryClient } from '@tanstack/react-query'
import { queryKeys } from '@/api/query-keys'
import {
  mapNotificationRow,
  PANEL_NOTIFICATION_PAGE_SIZE,
  type BellNotificationItem,
} from '../api/notifications-queries'

/**
 * Optimistically merges a `notification:new` socket payload into the panel list and
 * unread badge so the UI updates before the refetch round-trip completes.
 */
export function applySocketNotificationToCache(
  queryClient: QueryClient,
  raw: unknown,
): boolean {
  if (!raw || typeof raw !== 'object') return false

  const mapped = mapNotificationRow(raw)
  if (!mapped) return false

  let inserted = false
  queryClient.setQueryData<BellNotificationItem[]>(
    queryKeys.spNotifications.panelList(),
    (current) => {
      if (!current) return current
      if (current.some((row) => row.id === mapped.id)) return current
      inserted = true
      return [mapped, ...current].slice(0, PANEL_NOTIFICATION_PAGE_SIZE)
    },
  )

  if (inserted && !mapped.isRead) {
    queryClient.setQueryData<number>(queryKeys.spNotifications.unreadCount(), (current) =>
      typeof current === 'number' ? current + 1 : current,
    )
  }

  return inserted
}
